var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarrito(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20721 24C6.54655 24 5.98198 23.76 5.51351 23.292C5.04505 22.824 4.80481 22.26 4.80481 21.6C4.80481 20.94 5.04505 20.376 5.51351 19.908C5.98198 19.44 6.54655 19.2 7.20721 19.2C7.86787 19.2 8.43243 19.44 8.9009 19.908C9.36937 20.376 9.60961 20.94 9.60961 21.6C9.60961 22.26 9.36937 22.824 8.9009 23.292C8.43243 23.76 7.86787 24 7.20721 24ZM19.2192 24C18.5586 24 17.994 23.76 17.5255 23.292C17.0571 22.824 16.8168 22.26 16.8168 21.6C16.8168 20.94 17.0571 20.376 17.5255 19.908C17.994 19.44 18.5586 19.2 19.2192 19.2C19.8799 19.2 20.4444 19.44 20.9129 19.908C21.3814 20.376 21.6216 20.94 21.6216 21.6C21.6216 22.26 21.3814 22.824 20.9129 23.292C20.4444 23.76 19.8799 24 19.2192 24ZM6.18619 4.8L9.06907 10.8H17.4775L20.7808 4.8H6.18619ZM5.04505 2.4H22.7628C23.2192 2.4 23.5796 2.604 23.8198 3.012C24.0601 3.42 24.0721 3.84 23.8559 4.26L19.5916 11.94C19.3754 12.336 19.0751 12.648 18.7027 12.876C18.3303 13.104 17.9219 13.212 17.4895 13.212H8.54054L7.21922 15.612H21.6336V18.012H7.20721C6.30631 18.012 5.62162 17.616 5.16517 16.824C4.70871 16.032 4.68469 15.252 5.10511 14.472L6.72673 11.532L2.4024 2.4H0V0H3.9039L5.04505 2.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarrito);
export default __webpack_public_path__ + "static/media/carrito.d32e4a3c0550adba81d97be940866328.svg";
export { ForwardRef as ReactComponent };